import firebase  from "firebase";
// import "firebase/analytics";

// // Add the Firebase products that you want to use
// import "firebase/auth";
// import "firebase/firestore";
 // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDqK062UK4teuFOEf1U6I9Dd0fRDjs8eyA",
    authDomain: "todo-app-873fc.firebaseapp.com",
    databaseURL: "https://todo-app-873fc.firebaseio.com",
    projectId: "todo-app-873fc",
    storageBucket: "todo-app-873fc.appspot.com",
    messagingSenderId: "536898702895",
    appId: "1:536898702895:web:1692cd4343cb97f90180da",
    measurementId: "G-GWWDCDHSJE",
  });



const db = firebaseApp.firestore();

export default db ;


  